<template>
  <div class="ai-check-container">
    <!-- Header Banner -->
    <div class="ai-header-banner">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <div class="banner-left">
          <div class="ai-icon-pulse">
            <i class="el-icon-time"></i>
          </div>
          <div>
            <h1 class="banner-title">CẤU HÌNH TỰ ĐỘNG CHẠY (CRONJOB)</h1>
            <p class="banner-subtitle">Quản lý, lên lịch và cấu hình biểu thức thời gian chạy tự động (Cron Expression) cho các tác vụ nền.</p>
          </div>
        </div>
        <div class="banner-actions">
          <el-button type="success" class="gradient-btn green-btn" icon="el-icon-plus" @click="showCreateDynamicCronjobDialog">
            Thêm cấu hình mới
          </el-button>
        </div>
      </div>
    </div>

    <!-- Quick Stats Grid -->
    <div class="ai-stats-grid">
      <div class="stat-card blue">
        <div class="stat-icon"><i class="el-icon-setting"></i></div>
        <div class="stat-info">
          <p class="stat-label">Tổng số trang</p>
          <h3 class="stat-value">{{ totalPage }}</h3>
        </div>
      </div>
      <div class="stat-card green">
        <div class="stat-icon"><i class="el-icon-cpu"></i></div>
        <div class="stat-info">
          <p class="stat-label">Đang nạp (trang này)</p>
          <h3 class="stat-value">{{ listAutoRunConfigurationAdmin.length }}</h3>
        </div>
      </div>
      <div class="stat-card purple">
        <div class="stat-icon"><i class="el-icon-date"></i></div>
        <div class="stat-info">
          <p class="stat-label">Mẫu biểu thức</p>
          <h3 class="stat-value">Cron Expression</h3>
        </div>
      </div>
    </div>

    <!-- Filter Section -->
    <div class="glass-card mb-4">
      <el-form :inline="true" :model="dataSearch" class="modern-filter-form">
        <el-form-item label="Tên cấu hình">
          <el-input
            v-model="dataSearch.name"
            clearable
            placeholder="Nhập tên cấu hình..."
            class="modern-input"
            prefix-icon="el-icon-search"
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          />
        </el-form-item>

        <el-form-item label="Loại cấu hình">
          <el-select
            v-model="dataSearch.category"
            clearable
            placeholder="Tất cả"
            class="modern-input"
            :loading="loadingCategories"
            @change="handleSearch"
          >
            <el-option
              v-for="item in categoryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item class="filter-actions">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">Tìm kiếm</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- Table Section -->
    <div class="glass-card table-container">
      <el-table
        :data="listAutoRunConfigurationAdmin"
        v-loading="loadingData"
        element-loading-text="Đang tải danh sách cấu hình chạy tự động..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255,255,255,0.7)"
        class="modern-table"
        border
        highlight-current-row
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" align="center" />
        
        <el-table-column type="index" :index="calculateStt" label="STT" width="55" align="center" />

        <el-table-column prop="name" label="Tên hoạt động" min-width="200">
          <template slot-scope="{ row }">
            <el-button type="text" class="click-in-row-btn" @click="detailAction(row)">
              <i class="el-icon-document" style="margin-right: 4px;"></i>
              {{ row.name }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="Mã cấu hình (Job Key)" min-width="160" align="left">
          <template slot-scope="{ row }">
            <code class="code-badge">{{ row.jobKey }}</code>
          </template>
        </el-table-column>

        <el-table-column label="Loại cấu hình" min-width="130" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" type="info">{{ getCategoryLabel(row.category) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="Biểu thức thời gian (Cron)" min-width="180" align="left">
          <template slot-scope="{ row }">
            <span class="cron-badge">
              <i class="el-icon-time" style="color: #64748b; margin-right: 4px;"></i>
              <code>{{ row.cronExpression }}</code>
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="description" label="Mô tả cấu hình" min-width="250">
          <template slot-scope="{ row }">
            <span class="desc-text">{{ row.description || '—' }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Tác vụ" width="180" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="handleUpdate(row)">
              Sửa
            </el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="handleDelete(row)">
              Xóa
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination controls -->
      <div class="pagination-wrapper mt-3 flex justify-center">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentPageChange"
          :current-page.sync="dataSearch.page"
          :page-sizes="listSizePage"
          :page-size="dataSearch.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paginationTotal"
        >
        </el-pagination>
      </div>
    </div>

    <!-- Dialogs -->
    <CreateDynamicCronjobDialog
      :isCreateDynamicCronjob="isCreateDynamicCronjob"
      :category-options="categoryOptions"
      @close="handleCloseCreateDynamicCronjobDialog"
    />
    <UpdateDynamicCronjobDialog
      :id="id"
      :showDetail="showDetail"
      :isUpdateDynamicCronjob="isUpdateDynamicCronjob"
      :category-options="categoryOptions"
      @close="handleCloseUpdateDynamicCronjobDialog"
    />
  </div>
</template>

<script>
import cronjobService from "@/services/CronjobService/CronjobService";
import CreateDynamicCronjobDialog from "@/views/master/other/CreateDynamicCronjobDialog.vue";
import UpdateDynamicCronjobDialog from "@/views/master/other/UpdateDynamicCronjobDialog.vue";

export default {
  name: "AutoRunConfiguration",
  components: { CreateDynamicCronjobDialog, UpdateDynamicCronjobDialog },
  data() {
    return {
      loadingData: true,
      loadingCategories: false,
      listAutoRunConfigurationAdmin: [],
      categoryOptions: [],
      dataSearch: {
        name: "",
        category: "",
        page: 1,
        limit: 25
      },
      listSizePage: [25, 50, 100, 200, 500],
      totalPage: 0,
      isCreateDynamicCronjob: false,
      isUpdateDynamicCronjob: false,
      id: 0,
      showDetail: false,
      multipleSelection: []
    };
  },
  
  async created() {
    await this.loadCategories();
    this.findAllData();
  },

  computed: {
    paginationTotal() {
      if (!this.totalPage) {
        return 0;
      }
      if (this.dataSearch.page >= this.totalPage) {
        return (this.totalPage - 1) * this.dataSearch.limit
          + this.listAutoRunConfigurationAdmin.length;
      }
      return this.totalPage * this.dataSearch.limit;
    }
  },

  methods: {
    async loadCategories() {
      this.loadingCategories = true;
      try {
        const response = await cronjobService.getCronjobCategories();
        const categories = response.data.data || [];
        this.categoryOptions = categories.map((item) => ({
          value: item.code,
          label: item.displayName
        }));
      } catch (error) {
        console.error(error);
        this.$message.error("Không thể tải danh sách loại cấu hình");
      } finally {
        this.loadingCategories = false;
      }
    },

    async findAllData() {
      this.loadingData = true;
      try {
        const response = await cronjobService.findAllDynamicCronjobAdmin(
          this.dataSearch.name,
          this.dataSearch.category,
          this.dataSearch.page,
          this.dataSearch.limit
        );
        this.listAutoRunConfigurationAdmin = response.data.data.data || [];
        this.totalPage = response.data.data.totalPage || 0;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingData = false;
      }
    },

    handleSearch() {
      this.dataSearch.page = 1;
      this.findAllData();
    },

    getCategoryLabel(category) {
      if (!category) {
        const otherOption = this.categoryOptions.find((item) => item.value === "OTHER");
        return otherOption ? otherOption.label : "Khác";
      }
      const option = this.categoryOptions.find((item) => item.value === category);
      return option ? option.label : category;
    },

    handleSizeChange(value) {
      this.dataSearch.limit = value;
      this.dataSearch.page = 1;
      this.findAllData();
    },

    handleCurrentPageChange(value) {
      this.dataSearch.page = value;
      this.findAllData();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    calculateStt(index) {
      return (this.dataSearch.page - 1) * this.dataSearch.limit + index + 1;
    },

    showCreateDynamicCronjobDialog() {
      this.isCreateDynamicCronjob = true;
    },

    handleCloseCreateDynamicCronjobDialog() {
      this.isCreateDynamicCronjob = false;
      this.findAllData();
    },

    handleUpdate(row) {
      this.isUpdateDynamicCronjob = true;
      this.id = row.id;
      this.showDetail = false;
    },

    handleCloseUpdateDynamicCronjobDialog() {
      this.isUpdateDynamicCronjob = false;
      this.findAllData();
      this.showDetail = false;
    },

    detailAction(row) {
      this.isUpdateDynamicCronjob = true;
      this.id = row.id;
      this.showDetail = true;
    },

    handleDelete(row) {
      this.$confirm("Bạn có chắc chắn muốn xóa cấu hình đã chọn?", "Thông báo!", {
        distinguishCancelAndClose: true,
        confirmButtonText: "Có",
        closeOnClickModal: false,
        cancelButtonText: "Không",
        type: "warning"
      }).then(() => {
        cronjobService.deleteDynamicCronjob(row.id).then((res) => {
          if (res.data) {
            this.$message.success("Xóa hoạt động thành công");
            this.findAllData();
          } else {
            this.$message.error("Xóa hoạt thất bại");
          }
        }).catch((err) => {
          console.error(err);
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-check-container {
  padding: 16px;
  background-color: #f4f6fa;
  min-height: calc(100vh - 120px);
}

/* Header Banner Styling */
.ai-header-banner {
  position: relative;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 32px;
  margin-bottom: 24px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(30, 60, 114, 0.15);

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  }

  .banner-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    width: 100%;
  }

  .banner-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .ai-icon-pulse {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
    animation: iconPulse 3s infinite ease-in-out;

    i {
      font-size: 32px;
      color: #fff;
    }
  }

  .banner-title {
    color: #fff;
    font-size: 22px;
    margin: 0 0 6px 0;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .banner-subtitle {
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    margin: 0;
  }

  .gradient-btn {
    border: none;
    font-weight: 600;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
    }

    &.green-btn {
      background: linear-gradient(90deg, #10b981 0%, #059669 100%);
      box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
      &:hover { box-shadow: 0 6px 15px rgba(16, 185, 129, 0.4); }
    }
  }
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 0 25px rgba(255, 255, 255, 0.4);
  }
}

/* Stats Cards Grid */
.ai-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }

  .stat-info {
    flex: 1;
  }

  .stat-label {
    margin: 0 0 4px 0;
    font-size: 13px;
    color: #64748b;
  }

  .stat-value {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
  }

  /* Colors */
  &.blue {
    border-left: 4px solid #3b82f6;
    .stat-icon { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
  }
  &.green {
    border-left: 4px solid #10b981;
    .stat-icon { background: rgba(16, 185, 129, 0.1); color: #10b981; }
  }
  &.purple {
    border-left: 4px solid #8b5cf6;
    .stat-icon { background: rgba(139, 92, 246, 0.1); color: #8b5cf6; }
  }
}

/* Glassmorphic Cards */
.glass-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.table-container {
  background: #fff;
  padding: 12px;
}

/* Filter Forms */
.modern-filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;

  /deep/ .el-form-item {
    margin-bottom: 0 !important;
    margin-right: 0 !important;
  }

  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding: 0 8px 0 0;
  }

  .modern-input {
    width: 245px;
  }
}

/* Modern Table Styles */
.modern-table {
  border-radius: 8px;
  overflow: hidden;

  /deep/ th {
    background-color: #f8fafc !important;
    color: #475569;
    font-weight: 600;
    height: 48px;
  }

  /deep/ td {
    padding: 10px 0;
  }
}

.click-in-row-btn {
  font-weight: 600;
  color: #3b82f6;
  font-size: 14px;
  padding: 0;
  &:hover {
    color: #1d4ed8;
    text-decoration: underline;
  }
}

.code-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 6px;
  font-family: Consolas, Monaco, monospace;
  font-size: 12px;
  color: #64748b;
  border: 1px solid #cbd5e1;
}

.cron-badge {
  background: #faf5ff;
  border: 1px solid #f3e8ff;
  color: #6b21a8;
  padding: 4px 8px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  
  code {
    font-family: Consolas, Monaco, monospace;
    font-size: 12px;
  }
}

.desc-text {
  color: #475569;
  font-size: 13px;
  line-height: 1.5;
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}
</style>
